// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__lhGBb","detailsBorder":"styles_detailsBorder__2UWPI"};